import React from 'react';

const SellingCar = () => {
  return (
    <div className="container py-5">
      <h1 className="mb-4">Selling a Car</h1>

      <p>
        Once you're ready to sell your vehicle, follow these steps to ensure a smooth and successful auction experience.
      </p>

      <div className="mb-5">
        <h3 className="fs-4 mb-3 ">1. Submit Your Car</h3>
        <p>
          Provide all the details required accurately. We will ask for images, videos, a description, known flaws, modifications, servicing, and repair history. Don’t forget to mention the fuel consumption and any cool features the vehicle may have.
        </p>
        <p>
          It is your responsibility as a seller to list your vehicle honestly and accurately. Failure to do so may lead to issues on settlement day and could prevent the transaction from going through. You wouldn’t want that to happen when you’re buying a car through us, so ensure you’re listing your vehicle with full transparency.
        </p>
        <p>
          You also have the option to provide a pre-sale check of your vehicle. This will help boost the confidence of potential bidders and make your listing more attractive.
        </p>
        <p>
          Set a reserve price for your vehicle. Our team will review your listing and provide feedback within a day.
        </p>
      </div>

      <div className="mb-5">
        <h3 className="fs-4 mb-3 ">2. Listing Approved</h3>
        <p>
          Once your listing is approved, it will go live, and bidding will last for 7 days.
        </p>
        <p>
          We strongly recommend that you do not list your vehicle elsewhere while it's listed with us. Listing it on other platforms may affect the final price and its chances of selling here.
        </p>
        <ul className="ps-3">
          <li className="mb-3"><strong>Important:</strong> You cannot accept offers outside of the auction.</li>
          <li className="mb-3"><strong>Review Your Financing:</strong> If you have any outstanding payments, ensure you have a plan to clear them.</li>
          <li className="mb-3"><strong>Engage with the Community:</strong> Answer any questions from bidders to build trust and increase the chance of selling your car.</li>
        </ul>
        <p>
          Remember to avoid exchanging personal details with bidders. We will remove any listing and ban users who do not adhere to our auction rules.
        </p>
      </div>

      <div className="mb-5">
        <h3 className="fs-4 mb-3 ">3. Auction Completes</h3>
        <p>
          After 7 days, when the auction concludes, if the highest bid meets or exceeds your reserve price, you are legally bound to finalize the transaction. At that point, the highest bidder’s contact details will be shared with you.
        </p>
      </div>

      <div className="mb-5">
        <h3 className="fs-4 mb-3 ">4. Seller on Settlement Day</h3>
        <p>
          On settlement day, if the transaction does not proceed smoothly (e.g., if the buyer backs out for unforeseeable reasons), use the “Chat with Us” feature to notify us.
        </p>
        <p>
          We will provide you with the contact details of the second-highest bidder, and so on, to ensure you still have options to sell your vehicle.
        </p>
        <p>
          Once the transaction is complete and the ownership transfer is successful, please update the status to “Sold” via your dashboard. This helps us proudly share your success story with the rest of the community!
        </p>
        <p>
          We highly recommend that you print the <strong>Vehicle Auction Sales Agreement Form</strong> provided on your dashboard to keep a proper record of the transaction.
        </p>
      </div>

      <div className="text-center">
        <h3 className="fs-4 mt-4">Share Your Successful Auction</h3>
        <p>
          Don’t forget to click “deal closed” on your dashboard once the transaction is complete, and share your success with us!
        </p>
      </div>
    </div>
  );
};

export default SellingCar;
